export default {
  Email: '',
  Password: '',
  NewPassword: '',
  ConfirmPassword: '',
};
